import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css'; // optional for styling
import 'tippy.js/themes/light-border.css';

tippy(".popoverButton", {
    content(reference) {
        const id = reference.getAttribute("data-template");
        const template = document.getElementById(id);
        return template.innerHTML;
    },
    allowHTML: true,
    trigger: "click",
    interactive: true,
    theme: "light-border",
    placement: "bottom"
});